import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import type {
  ImmutableEntity,
  ParagraphEntity,
} from '@uncinc/react-drupal-core/types';

import './style.scss';

interface ParagraphProjectsFilteredProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<ParagraphEntity>;
}

const ParagraphProjectsFiltered: React.FC<ParagraphProjectsFilteredProps> = () => (
  <div className="Paragraph ParagraphProjectsFiltered">
    <Container>
      <View
        classes="row"
        id="projects_filtered"
        display="projects_filtered"
        storageType="url"
        withProvider
      />
    </Container>
  </div>
);

export default ParagraphProjectsFiltered;
